import React from 'react';
import { Link } from 'react-router-dom';
import { FaBuilding, FaBars, FaTimes } from 'react-icons/fa';
import { useModal } from '../../contexts/ModalContext';
import './Header.css';

const Header = () => {
  const { isModalOpen, toggleModal } = useModal();

  return (
    <header className="header">
      <div className="logo">
        <FaBuilding className="logo-icon" />
        <h1>Skylight Capital</h1>
      </div>
      <nav className="nav">
        <Link className="link" to="/">Inicio</Link>
        <Link className="link" to="/about">Sobre Nosotros</Link>
        <Link className="link" to="/contact">Contacto</Link>
      </nav>
      <div className="mobile-menu-icon" onClick={toggleModal}>
        {isModalOpen ? <FaTimes /> : <FaBars />}
      </div>
      <div className={`mobile-modal ${isModalOpen ? 'open' : ''}`}>
        <button className="close-button" onClick={toggleModal}><FaTimes /></button>
        <Link className="link" to="/" onClick={toggleModal}>Inicio</Link>
        <Link className="link" to="/about" onClick={toggleModal}>Sobre Nosotros</Link>
        <Link className="link" to="/contact" onClick={toggleModal}>Contacto</Link>
      </div>
    </header>
  );
}

export default Header;
